import { useState, useEffect, useRef } from "react"

import { supabase } from './SupabaseClient'

import { useRecoilState } from 'recoil'
import {authSessionState} from '../atoms/auth'
import { Link } from "react-router-dom";

export default function DashboardLayout(props: { children: any }) {

    const [session, set_session] = useRecoilState(authSessionState)

    const [profile_open, set_profile_open] = useState(false)
    const [aside_open, set_aside_open] = useState(true)
    
    const profile_ref = useRef<any>();

    //useOnClickOutside(profile_ref, () => set_profile_open(false));

    const signOut = async () => {
        console.log("sign_out")

        console.log('SIGN OUT')
        const { error } = await supabase.auth.signOut()
        console.log(error)


    }

    return (
        <main className="min-h-screen w-full bg-white text-gray-700" x-data="layout">
            <header className="fixed flex w-full items-center justify-between border-b-2 border-gray-200 bg-white p-2 z-20">
                <div className="flex items-center space-x-2">
                    <button 
                        type="button" className="text-3xl"  
                    >
                        <i className="bx bx-menu"></i></button>
                    <div>BirthT Online Print</div>
                </div>

                <div>
                    <button type="button" 
                        className="h-9 overflow-hidden rounded-full"
                        onClick={()=>set_profile_open((pre_open)=> !pre_open) }
                        //ref={profile_ref}
                    >
                        {
                        //<img src="https://plchldr.co/i/40x40?bg=111111" alt="plchldr.co" />
                        }
                        {session.user.email}
                    </button>

                {
                    profile_open &&
                <div className="absolute right-2 mt-1 w-48 divide-y divide-gray-200 rounded-md border border-gray-200 bg-white shadow-md"
                    x-transition>
                    <div className="flex items-center justify-center  space-x-2 p-2">
                        {
                         //<img src="https://plchldr.co/i/40x40?bg=111111" alt="plchldr.co" className="h-9 w-9 rounded-full" />
                        }
                        <div className="font-medium">{session.user.email}</div>
                    </div>

                    <div className="flex flex-col space-y-3 p-2">
                        <a href="#" className="transition hover:text-blue-600">My Profile</a>
                        <a href="#" className="transition hover:text-blue-600">Edit Profile</a>
                        <a href="#" className="transition hover:text-blue-600">Settings</a>
                    </div>

                    <div className="p-2">
                        <button  onClick={signOut} className="flex items-center space-x-2 transition hover:text-blue-600">
                            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1">
                                </path>
                            </svg>
                            <div>Log Out</div>
                        </button>
                    </div>
                </div>
                }
                </div >
            </header >

        <div className="flex overflow-hidden">
            <aside className="fixed w-40 flex-col space-y-2 border-r-2 border-gray-200 bg-white p-2 h-screen z-10 pt-20" 
                x-show="asideOpen">
                <Link to="/" className="flex items-center space-x-1 rounded-md px-2 py-3 hover:bg-gray-100 hover:text-blue-600">
                    <span className="text-2xl"><i className="bx bx-home"></i></span>
                    <span>プリントデータ</span>
                </Link>

                <Link to="/printer" className="flex items-center space-x-1 rounded-md px-2 py-3 hover:bg-gray-100 hover:text-blue-600">
                    <span className="text-2xl"><i className="bx bx-cart"></i></span>
                    <span>プリンター管理</span>
                </Link>

                <Link to="/queue" className="flex items-center space-x-1 rounded-md px-2 py-3 hover:bg-gray-100 hover:text-blue-600">
                    <span className="text-2xl"><i className="bx bx-cart"></i></span>
                    <span>キューリスト</span>
                </Link>

            </aside>

            <div className="h-[1900] w-full bg-white relative overflow-y-auto ml-40">
                <main className="mt-5">
                    {props.children}
                </main>
            </div>
        </div>
    </main >
    )
}